import { SigningRequestLayout } from './SigningRequestLayout';

export function SignMessage() {
  return <SigningRequestLayout isTransaction={false} />;
}
